/* eslint-disable @typescript-eslint/naming-convention */
// Package Imports
import axios from 'axios';
import { type HttpError } from '@refinedev/core';

export const axiosInstance = axios.create();

// axiosInstance.interceptors.request.use((request: AxiosRequestConfig) => {
//   const token = JSON.parse(localStorage.getItem('authTokenRefine'));
//   if (request.headers) {
//     request.headers.Authorization = `Bearer ${token}`;
//   } else {
//     request.headers = {
//       Authorization: `Bearer ${token}`,
//     };
//   }
//   return request;
// });

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const customError: HttpError = {
      ...error,
      message: error.response?.data?.message,
      statusCode: error.response?.status,
    };
    return Promise.reject(customError);
  }
);

export default axiosInstance; // Export the axiosInstance
